export class ContainerLogBookIdRequestDTO{
    containerLogBookId: number;
    
    constructor(containerLogBookId: number){
        this.containerLogBookId = containerLogBookId;
    }
}